import { render, staticRenderFns } from "./UnblockContact.vue?vue&type=template&id=0d9218cc&"
import script from "./UnblockContact.vue?vue&type=script&lang=js&"
export * from "./UnblockContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports